import { createAction, props } from '@ngrx/store';

export const showErrorMessage = createAction(
  '[Toast] Show Error Message',
  props<{ response: string | null }>()
);

export const showSuccessMessage = createAction(
  '[Toast] Hide Success Message',
  props<{ response: string | null }>()
);

export const showWarningMessage = createAction(
  '[Toast] Hide Warning Message',
  props<{ response: string | null }>()
);

